/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiGreetingsIdMutationRequest, PutApiGreetingsIdMutationResponse, PutApiGreetingsIdPathParams, PutApiGreetingsId400, PutApiGreetingsId401, PutApiGreetingsId403, PutApiGreetingsId404, PutApiGreetingsId500 } from "../../types/PutApiGreetingsId.ts";
import { putApiGreetingsIdMutationResponseSchema, putApiGreetingsIdMutationRequestSchema } from "../../zod/GreetingsSchemas/putApiGreetingsIdSchema.ts";

function getPutApiGreetingsIdUrl({ id }: { id: PutApiGreetingsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/greetings/${id}` as const }  
  return res
}

/**
 * @summary Редактирование шаблона приветственного экрана
 * {@link /api/greetings/:Id}
 */
export async function putApiGreetingsId({ id, data }: { id: PutApiGreetingsIdPathParams["Id"]; data?: PutApiGreetingsIdMutationRequest }, config: Partial<RequestConfig<PutApiGreetingsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiGreetingsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiGreetingsIdMutationResponse, ResponseErrorConfig<PutApiGreetingsId400 | PutApiGreetingsId401 | PutApiGreetingsId403 | PutApiGreetingsId404 | PutApiGreetingsId500>, PutApiGreetingsIdMutationRequest>({ method : "PUT", url : getPutApiGreetingsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiGreetingsIdMutationResponseSchema.parse(res.data)
}